import { tx } from '../i18n/extra';

const TZ = 'Europe/Berlin';
const DAY_MS = 86_400_000;

const dateFmt = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
  timeZone: TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const timeFmt = new Intl.DateTimeFormat('de-DE', { timeZone: TZ, hour: '2-digit', minute: '2-digit' });
const dayKeyFmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });

export function formatDate(iso: string): string {
  return dateFmt.format(new Date(iso));
}

export function formatDateTime(iso: string): string {
  return dateTimeFmt.format(new Date(iso));
}

export function formatTime(date: Date): string {
  return timeFmt.format(date);
}

/** Calendar day in Berlin as YYYY-MM-DD; used to count whole days, not 24 h blocks. */
export function berlinDayKey(date: Date): string {
  return dayKeyFmt.format(date);
}

/** Whole calendar days between `iso` and `now` in Berlin time (0 = today). */
export function ageInDays(iso: string, now: Date): number {
  const a = Date.parse(`${berlinDayKey(new Date(iso))}T00:00:00Z`);
  const b = Date.parse(`${berlinDayKey(now)}T00:00:00Z`);
  return Math.max(0, Math.round((b - a) / DAY_MS));
}

/** "gerade eben", "vor 5 Minuten", "vor 3 Stunden", "gestern", "vor 4 Tagen", then the date. */
export function formatRelative(iso: string, now: Date): string {
  const diff = now.getTime() - Date.parse(iso);
  if (diff < 3_600_000) return tx.time.minutesAgo(Math.max(0, Math.floor(diff / 60_000)));
  const days = ageInDays(iso, now);
  if (days === 0) return tx.time.hoursAgo(Math.floor(diff / 3_600_000));
  if (days === 1) return tx.time.yesterday;
  if (days < 14) return tx.time.daysAgo(days);
  return formatDate(iso);
}

export function percent(value: number, digits = 1): string {
  return `${(value * 100).toLocaleString('de-DE', { maximumFractionDigits: digits, minimumFractionDigits: digits })} %`;
}
